<template>
  <div class="pwc-thanks-info" :style="cStyle">
    <!-- <v-img :src="logo" class="pwc-youplus-logo" /> -->

    <div class="pwc-info-tilte">
      感谢参与！
    </div>
    <div class="pwc-info-content">
      扫码关注普华永道You Plus特训计划
      回复关键词【测试】
      了解未来求职发展可能面临的机遇与挑战
    </div>
    <div class="pwc-info-qrcode">
      <img :src="youplusWechatQrcode">
    </div>
  </div>
</template>

<script>
import youplusWechatQrcode from '@/assets/you-plus-wechat-qrcode.jpg'
import logo from '@/assets/logo.png'
import Detect from '@/util/detect'
const isMobile = Detect(window.navigator.userAgent).mobile()

export default {
  data() {
    return {
      youplusWechatQrcode,
      logo
    }
  },
  computed: {
    cStyle() {
      return isMobile ? {} : { height: '90vh' }
    }
  }
}
</script>

<style lang="scss" scoped>
.pwc-thanks-info {
    padding-top: 32px;
    .pwc-info-tilte {
        margin-top: 26px;
        margin-bottom: 32px;
    }
    .pwc-info-content {
        font-weight: bold;
        margin-bottom: 16px;
    }
    .pwc-info-qrcode {
        text-align: center;
        img {
            width:180px;
            height:180px;
        }
    }
    .pwc-info-tilte, .pwc-info-content {
        font-size: 18px;
    }
    max-width:240px;
    margin: auto;
}
</style>
